<template>
  <div class="elite-tabs-wrapper-content">
    <h3 class="mb-4">
      {{ `${subscription.firstname} ${subscription.lastname}` }} -
      {{ $t("COMMON.LOGS") }}
    </h3>
    <log-list-table :filterSubject="subscription" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "subscription-view-logs",

  components: { LogListTable },

  props: ["subscription"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
